<!-- Docs

Props:
1- Design Cell
  title => String
  icon => (class of line awesome)

2- showIf => condition must be a true to show cell
   permission => admin permission name (or array, any of them) required to show cell

3- Routes
  ifNavigate => Boolean
  routerName => String
  routerPath => String
  routerParams => String

4- takeAction ($emit)
   takeActionParams => (get value of key in row)

5- change Status (with api)
-->
<template>
  <div>
    <div v-if="cellActions.actions.length">

      <div
          v-if="!showActionInList"
          class="d-flex justify-content-start w-full gap-20"
      >
        <template v-for="(i, key) in cellActions.actions">
      <span
          v-if="hasPer(i.permission) && (i.showIf ? i.showIf(dataItem) : true)"
          :key="key"
          @click="fireAction(i)"
      >
        <i v-b-tooltip.top="`${i.text}`" :class="[i.icon, `text-${i.color}`]" />
      </span>
        </template>
      </div>

      <b-dropdown
          v-else
          class="actions-dropdown"
          right
          variant="link"
          no-caret
      >
        <template #button-content>
          <svg width="21" height="20">
            <circle cx="10" cy="5" r="1.5"/>
            <circle cx="10" cy="10" r="1.5"/>
            <circle cx="10" cy="15" r="1.5"/>
          </svg>
        </template>

        <template v-for="(i, key) in cellActions.actions">
          <b-dropdown-item-button
              v-if="hasPer(i.permission) && (i.showIf ? i.showIf(dataItem) : true)"
              :key="key"
              @click="fireAction(i)"
          >
            <i :class="[i.icon, `text-${i.color}`, 'mr-2']" />
            {{ i.text }}
          </b-dropdown-item-button>
        </template>

      </b-dropdown>

    </div>

  </div>
</template>
<script>
import EventBus from '@/eventBus'
export default {
  props: {
    cellActions: {
      type: Object
    },
    dataItem: {
      type: Object
    },
    showActionInList: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalTitle: '',
      modalColor: 'danger'
    }
  },
  methods: {
    fireAction (action) {
      if (action.ifNavigate) {
        let params = {}
        let path = action.routePath || null

        const actionParams = action.routeParams || null
        if (action.getParams) {
          params = action.getParams(this.dataItem)
        } else if (action.routePath) {
          const pathParams = action.routePath.split('/').filter(e => e.includes(':')).map(e => e.replace(':', ''))
          pathParams.forEach(e => {
            params[e] = this.dataItem[e]
            path = path.replace(`:${e}`, this.dataItem[e])
          })
        } else if (Array.isArray(actionParams)) {
          actionParams.forEach(e => {
            params[e] = this.dataItem[e]
          })
        } else params[actionParams || 'id'] = this.dataItem[actionParams || 'id']
        this.$router.push(
          path || {
            name: action.routeName,
            params
          }
        )
      } else if (action.actionName) {
        let objData = {}
        if (action.actionParams === 'fullObj') {
          objData = this.dataItem
        } else if (action.actionParams) {
          action.actionParams.forEach(params => {
            if (this.dataItem[params]) {
              objData[params] = this.dataItem[params]
            }
          })
        }
        this.$root.$emit(action.actionName, objData)
      } else if (action.showAlert) {
        EventBus.$emit('openDeleteModal', {
          actionHeader: action.actionHeader ? action.actionHeader : 'Delete',
          titleHeader: action.titleHeader ? action.titleHeader : '',
          textContent: action.textContent ? this.$_.get(this.dataItem, action.textContent) : '',
          url: action.url ? action.url : '',
          rowId: action.getRowId ? action.getRowId(this.dataItem) : this.dataItem.id,
          question: action.question ? action.question : `Are you sure you want delete this ${action.titleHeader}?`,
          textDeleteButton: action.textDeleteButton ? action.textDeleteButton : `YES, ${action.actionHeader.toUpperCase()}`,
          textCancelButton: action.textCancelButton ? action.textCancelButton : 'NO, CANCEL',
          icon: action.iconClass ? action.iconClass : 'las la-trash-alt',
          type: action.type ? action.type : 'delete',
          method: action.method ? action.method : 'delete',
          actionOnAlert: action.actionOnAlert ? action.actionOnAlert : '',
          additionalRoute: action.additionalRoute || ''
        })
      }
    }
  }
}
</script>
